import React from 'react';
import { Box, Text } from '@sparknz/spark-pattern-library';

export default function ProductNotFoundErrorMessage() {
  return (
    <Box
      py={['s5', 's10']}
      px={['s3', 's5']}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text variant="bodyMMedium">Product not found.</Text>
    </Box>
  );
}
